<template>
  <v-container fluid>
    <h3 class="mb-5">Duomenų teikėjas</h3>
    <div class="dataContainer">
      <v-row>
        <v-col cols="12" md="12" v-if="showTeikejasList">
          <el-autocomplete
            :items="teikejasList"
            itemvalue="asm_asmens_kodas"
            itemtext="asm_pavadinimas"
            return-object
            label="Duomenų teikėjas"
            :tooltip="`${ntrTooltipPrefix} Teikėjas. Duomenų teikėjas`"
            v-model="formData"
            @change="checkData()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <el-text-field
            label="Vardas"
            :tooltip="`${ntrTooltipPrefix} Teikėjas. Vardas`"
            :readonly="true"
            v-model="formData.asm_fiz_vardas"
          />
        </v-col>
        <v-col cols="12" md="6">
          <el-text-field
            label="Pavardė"
            :tooltip="`${ntrTooltipPrefix} Teikėjas. Pavardė`"
            :readonly="true"
            v-model="formData.asm_fiz_pavarde"
          />
        </v-col>
        <v-col cols="12" md="12" v-if="showPavadinimas">
          <el-text-field
            label="Pavadinimas"
            :tooltip="`${ntrTooltipPrefix} Teikėjas. Pavadinimas`"
            :readonly="true"
            v-model="formData.asm_pavadinimas"
          />
        </v-col>
        <template v-if="isNotaras">
          <v-col cols="12" md="12" v-if="showPareigos">
            <el-text-field
              label="Pareigos"
              :tooltip="`${ntrTooltipPrefix} Teikėjas. Pareigos`"
              :readonly="!editPareigos"
              v-model="formData.asm_pareigos"
              @blur="editPareigos ? checkData() : null"
            />
          </v-col>
          <v-col cols="12" md="12" v-if="showKontora">
            <el-text-field
              label="Notaro biuro pavadinimas"
              :tooltip="`${ntrTooltipPrefix} Teikėjas. Kontora`"
              :readonly="true"
              v-model="formData.asm_kontora"
            />
          </v-col>
          <v-col cols="12" md="12" v-if="showAdresas">
            <el-text-field
              :readonly="true"
              label="Notaro biuro adresas"
              :tooltip="`${ntrTooltipPrefix} Teikėjas. Adresas`"
              v-model="formData.adr_text"
            />
          </v-col>
        </template>
      </v-row>
    </div>

    <v-footer class="form-footer" v-if="!isReadonly">
      <v-spacer></v-spacer>
      <el-button
        primary
        @click.native="checkErrorsClick()"
        :loading="loadingTikrinti"
        >Tikrinti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import busena from '@/mixins/busenaNtr'
import tooltipNtr from '@/mixins/tooltipNtr'
import unsavedData from '@/mixins/unsavedData'
import checkErrors from '@/mixins/checkErrors'

export default {
  name: 'RegPrasymasTeikejas',
  props: {
    readonlyForm: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },
  mixins: [userRole, busena, tooltipNtr, unsavedData, checkErrors],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      formData: {},
      teikejai: [],
    }
  },
  computed: {
    ...mapGetters(['prasymasID', 'prasymasSistema', 'userKontoraTipas']),
    isSistemaSavitarna() {
      return this.prasymasSistema === 'savitarna'
    },
    isReadonly() {
      return this.readonly
    },
    isReadonlyForm() {
      return this.readonlyForm
    },
    teikejasList() {
      return this.teikejai.map(item => {
        return item
      })
    },
    isTeikejasList() {
      return this.teikejasList.length > 1
    },
    showTeikejasList() {
      return (
        (this.isRengiamas || this.isGrazintas) &&
        !this.isSistemaSavitarna &&
        this.isTeikejasList &&
        !this.isReadonlyForm
      )
    },
    kontoraTipas() {
      let tipas = parseInt(
        this.formData.sasm_kontora_tipas ?? this.userKontoraTipas
      )

      switch (tipas) {
        case 13:
          return 'notaras'
        case 5:
          return 'antstolis'
        default:
          return 'kita'
      }
    },
    isNotaras() {
      return !this.isSistemaSavitarna
    },
    showPareigos() {
      return this.isNotaras
    },
    showKontora() {
      return this.isNotaras && this.formData.sasm_kontora_tipas !== null
    },
    showAdresas() {
      return this.isNotaras
    },
    editPareigos() {
      return (
        (this.isRengiamas || this.isGrazintas) &&
        this.formData.redaguojamos_pareigos &&
        !this.isReadonlyForm
      )
    },
    showPavadinimas() {
      return (
        this.isSistemaSavitarna &&
        this.formData.amnt_tipas &&
        this.formData.amnt_tipas === 2
      )
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.loadingTikrinti = true
      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/teikejas`)
        .then(res => {
          this.teikejai = res.data.list
          if (this.teikejai.length == 1 && !this.isReadonlyForm) {
            this.formData = this.teikejai[0]
          } else {
            this.formData = res.data.teikejas ?? {}
          }
          this.$nextTick(() => {
            this.initialForm()
          })
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.loadingTikrinti = false
          this.pageloading = false
        })
    },
    saveData(toRoute, afterSave) {
      if (toRoute) {
        this.goToRoute()
        return
      }
      if (this.isReadonlyForm) {
        return
      }
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          let data = this.formData
          data.pra_id = this.prasymasID

          this.$axios
            .post(`ntrpaslaugos/prasymas/${this.prasymasID}/teikejas`, data)
            .then(res => {
              this.updateErrors()
              this.initialForm()
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
          this.$root.$emit('cancelTabNavigation')
        }
      })
    },
    cancelData() {
      this.getData()
    },
    checkErrorsClick() {
      this.loadingTikrinti = true
      this.checkNtrErrors()
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 800px;
}
</style>
